import { Pressable, StyleSheet, View } from "react-native";

import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import CustomText from "../../common/general/CustomText/CustomText";
import { Cloud } from "../../svgs/CustomCoursework";
import useFileUpload, { UseFileUploadHookProps } from "../../../hooks/useFileUpload";
import { MIME_TO_EXTENSION_MAP } from "./fileTypeHelper";
import { colors } from "../../../styles/design-system";

const FileUploadComponent: React.FC<UseFileUploadHookProps> = ({
  storagePath,
  beforeUpload,
  afterUpload,
  onError,
  multiple,
}) => {
  const { handleFileUpload, maxFileSize, allowedMimeTypes } = useFileUpload({
    storagePath,
    beforeUpload,
    afterUpload,
    onError,
    multiple,
  });

  return (
    <Pressable
      onPress={handleFileUpload}
      accessibilityRole="button"
      accessibilityLabel="Browse file"
      role="button"
      aria-label="Browse file"
      tabIndex={0}
      // @ts-expect-error — onKeyDown is a web-only prop not in RN types
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleFileUpload();
        }
      }}>
      <View style={styles.fileUpload}>
        <Cloud />
        <CustomSpacing type="vertical" size="s" />
        <CustomText text="Browse file" size="m" style={{ color: "#344054" }} />
        {allowedMimeTypes.length > 0 ? (
          <CustomText
            text={`Accepted file types`}
            interpolation={{
              acceptedFileTypes: `${(allowedMimeTypes as string[]).map((mime) => MIME_TO_EXTENSION_MAP[mime]).join(", ")}`,
            }}
            size="xs"
            style={{ color: colors.grey[600] }}
          />
        ) : null}
        {maxFileSize ? (
          <CustomText
            text={`Max file size`}
            interpolation={{
              maxFileSize: `${Math.floor(maxFileSize / 1024 / 1024)}`,
            }}
            size="xs"
            style={{ color: colors.grey[600] }}
          />
        ) : null}
      </View>
    </Pressable>
  );
};

export default FileUploadComponent;

const styles = StyleSheet.create({
  fileUpload: {
    borderWidth: 1,
    borderColor: "#3E68FE",
    borderRadius: 8,
    borderStyle: "dashed",
    padding: 16,
    alignItems: "center",
    backgroundColor: "#F2F5FF",
  },
});
